import { AspectRatio, Flex, Text, VStack } from '@chakra-ui/react'
import Image from 'next/image'

const Problem = () => {
  return (
    <Flex
      w="100%"
      justifyContent="space-between"
      pt={{
        base: '40px',
        sm: '10px',
        md: '40px'
      }}
      pb={{
        base: '20px',
        sm: 0
      }}
      flexDir={{
        base: 'column',
        sm: 'row'
      }}
    >
      <VStack
        w={{
          base: '100%',
          sm: '70%',
          lg: '70%',
          xl: '100%'
        }}
        mt={{
          sm: '60px',
          md: '78px',
          lg: '50px',
          xl: '90px'
        }}
        alignItems="flex-start"
      >
        <Text
          textStyle="gripProblemTitle"
          textTransform="uppercase"
          textAlign="left"
          w={{
            base: '90%',
            xl: '75%',
            '2xl': '75%'
          }}
          zIndex={100}
        >
          LOOK NO FURTHER THAN THE ARCTIC GRIP TUMBLER
        </Text>
        <Text
          textStyle="gripContentSmall"
          textAlign="left"
          w={{
            base: '90%',
            xl: '75%',
            '2xl': '80%'
          }}
          zIndex={100}
        >
          The ultimate solution to keeping your beverages secure, at the perfect
          temperature, and always within reach. Crafted with precision and
          designed for the modern lifestyle, this tumbler is your go-to choice
          for every occasion.
        </Text>
      </VStack>

      <VStack
        w={{
          base: '100%',
          sm: '20%'
        }}
        position="relative"
        mt="28px"
        display={{
          base: 'flex',
          lg: 'none'
        }}
      >
        <AspectRatio
          w={{
            base: '180px',
            sm: '260px',
            md: '300px'
          }}
          ratio={1 / 1}
          position="relative"
          zIndex={10}
          mb={4}
        >
          <Image
            src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/tumbler-check-1711632565104.png"
            alt="tumbler check"
            fill
          />
        </AspectRatio>

        <VStack
          position="absolute"
          top={{
            base: '80%',
            sm: '83%',
            md: '83%'
          }}
          left={{
            md: '-74px'
          }}
          alignItems="flex-start"
        >
          <AspectRatio
            w={{
              base: '180px',
              sm: '260px',
              md: '300px'
            }}
            ratio={480 / 90}
            position="relative"
          >
            <Image
              src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/wood-1711632565102.png"
              alt="wood"
              fill
            />
          </AspectRatio>
        </VStack>

        <VStack
          position="absolute"
          top={{
            base: '70%',
            sm: '70%',
            md: '65%'
          }}
          left="47%"
          alignItems="flex-start"
          zIndex={10}
        >
          <AspectRatio
            mt={0}
            w={{
              base: '40px',
              sm: '40px',
              md: '80px'
            }}
            ratio={1 / 1}
            position="relative"
          >
            <Image
              src="https://habbit-sg.s3.ap-southeast-1.amazonaws.com/icon-check-1711632565104.png"
              alt="icon check"
              fill
            />
          </AspectRatio>
        </VStack>
      </VStack>
    </Flex>
  )
}

export default Problem
